export default function isAboveTablet() {
    return window.matchMedia('(min-width: 1024px)');
}
